import type { JSX } from 'react';

import { Button, Text } from '@change/ds-core-ui/next';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { Translate } from '@change-corgi/core/react/i18n';

type SharingToolsCardWrapperVariant2Props = {
	Preview: React.ReactNode;
	titleKey: TranslationKey;
	descriptionKey: TranslationKey;
	primaryActionTextKey: TranslationKey;
	primaryActionOnClick: () => void;
};
export function SharingToolsCardWrapperVariant2({
	Preview,
	titleKey,
	descriptionKey,
	primaryActionTextKey,
	primaryActionOnClick,
}: SharingToolsCardWrapperVariant2Props): JSX.Element {
	return (
		<div className="bg-fill-information-weaker flex h-[422px] w-[295px] max-w-full flex-col gap-5 overflow-hidden rounded-xl px-5 py-6 md:h-[210px] md:w-full md:max-w-full md:flex-row-reverse md:items-center md:gap-8 md:px-8 md:py-5">
			{/* Post Preview Area - Fixed minimum size, can grow to accommodate content */}
			<div className="flex h-[178px] w-full flex-shrink-0 items-center justify-center md:h-full md:w-auto md:min-w-[280px] md:max-w-[308px]">
				{Preview}
			</div>
			{/* Content Area - Flexible, adapts to available space and content */}
			<div className="flex w-full min-w-0 flex-col gap-5 overflow-hidden md:h-fit md:w-0 md:flex-1 md:basis-0 md:justify-around">
				<div className="flex min-w-0 flex-col gap-3 overflow-hidden">
					<Text variant="heading" size="x-small" className="break-words">
						<Translate value={titleKey} />
					</Text>
					<Text variant="body" className="break-words">
						<Translate value={descriptionKey} />
					</Text>
				</div>
				<Button
					data-qa="primary-action-button"
					className="w-full md:w-fit md:flex-shrink-0"
					variant="secondary-solid"
					size="small"
					onClick={primaryActionOnClick}
				>
					<Translate value={primaryActionTextKey} />
				</Button>
			</div>
		</div>
	);
}
